import React, { useCallback, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import Table from '@/src/components/Antd/Table/SizeFittingTable';

import update from 'immutability-helper';
import { MenuOutlined } from '@ant-design/icons';
import css from './css.less';

//const type = 'DraggableRow';

const DraggableRow = ({
  index,
  moveRow,
  className,
  style = {},
  availabilityConfig = {},
  rowKey,
  hideAllDragHandlers,
  __key,
  type = 'DraggableRow',
  ...restProps
}) => {
  const ref = useRef();
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || ({} as any);
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName:
          dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item: any) => {
      moveRow(item.index, index);
    },
  });
  const [, drag, preview] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const _style: any = {};

  const currentItem = availabilityConfig[__key];

  // console.log('rowKey', rowKey);
  // console.log('rowKey()', rowKey());
  // console.log('availabilityConfig', availabilityConfig);
  const { disableDrag, hideDragger } = currentItem || {};

  const _className = disableDrag ? css.unDragable : '';
  if (!disableDrag && !hideDragger) {
    drop(drag(ref));
    //_style.cursor = 'move';
  }

  const { children, ...rest } = restProps;
  //console.log('children', Array.isArray(children));
  //  console.log('children', children);
  const a = React.useMemo(() => {
    if (Array.isArray(children) && !hideAllDragHandlers) {
      return React.Children.map(children, (i, index) => {
        if (index === 0) {
          if (!hideDragger) {
            const ele = React.cloneElement(i, { ref: ref });
            return ele;
          } else {
            const ele = React.cloneElement(
              i,
              {},
              <div style={{ width: 32 }} />,
            );
            return ele;
          }
        }
        return i;
      });
    }
    return null;
  }, [children, hideAllDragHandlers, hideDragger]);

  // children[0].render = () => <div>123</div>;

  return (
    <tr
      ref={preview}
      className={`${className} ${_className} ${isOver ? dropClassName : ''}`}
      style={{
        ...style,
        ..._style,
      }}
      {...rest}>
      {a || children}
    </tr>
  );
};
//onTableChange为必传，每次排序后触发

//hideAllDragHandlers -> 所有拖拽按钮是否隐藏 无法拖拽
const EditDraggableTable = (props) => {
  const {
    columns,
    dataSource,
    onTableChange,
    rowKey,
    hideAllDragHandlers,
    availabilityConfig,
    //{[rowKey]:{
    //  disableDrag:boolean,
    //  hideDragger:boolean,

    // }}
    // dragHandle,
    type,
    error,
    ...rest
  } = props;

  const _columns = columns;

  const expandable = !hideAllDragHandlers
    ? {
        expandedRowRender: () => <p></p>,
        expandIcon: (data) => {
          //前置icons
          const { record } = data;
          const { hideDragHandler } = record || {};
          return !hideDragHandler ? (
            <MenuOutlined rev className={css.dragHandle} role={'dragHandler'} />
          ) : null;
        },
      }
    : {};

  const components = React.useMemo(() => {
    return {
      body: {
        row: (p) => {
          const k = p['data-row-key'];
          return DraggableRow({
            ...p,
            rowKey,
            hideAllDragHandlers,
            availabilityConfig,
            __key: k,
            type,
          });
        },
      },
    };
  }, [hideAllDragHandlers, availabilityConfig]);

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = dataSource[dragIndex];
      onTableChange(
        update(dataSource, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        }),
        {
          from: dragIndex,
          to: hoverIndex,
        },
      );
    },
    [dataSource],
  );

  return (
    <React.Fragment>
      {error && <div className={css.errContainer}>{error}</div>}
      <Table
        rowKey={rowKey}
        columns={_columns}
        className={css.droppableTable}
        dataSource={dataSource}
        components={components}
        onRow={(record, index) => ({
          index,
          moveRow,
        })}
        expandable={expandable}
        {...rest}
      />{' '}
    </React.Fragment>
  );
};

export default EditDraggableTable;
